// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var TextInput$ReactHooksTemplate = require("../common/TextInput.res.js");

var emptyFormInfo = {
  customer_id: ""
};

function QuickSurveyForm(props) {
  var match = React.useState(function (param) {
        return emptyFormInfo;
      });
  var setFormInfo = match[1];
  var formInfo = match[0];
  var match$1 = React.useState(function (param) {
        return "";
      });
  var setformSubmitMessage = match$1[1];
  var formSubmitMessage = match$1[0];
  var buildSurveyFormDict = function (form) {
    var params = {};
    params["customer_id"] = form.customer_id;
    params["api_key"] = "2f129c96-9077-485d-b6fa-61619c284ffe";
    return params;
  };
  var handleCustomerIDChange = function ($$event) {
    var customer_id = Utils$ReactHooksTemplate.formTargetValue($$event);
    Curry._1(setFormInfo, (function (param) {
            return {
                    customer_id: customer_id
                  };
          }));
  };
  var tmp = formSubmitMessage === "" ? JsxRuntime.jsx(JsxRuntime.Fragment, {}) : JsxRuntime.jsx(JsxRuntime.Fragment, {
          children: Caml_option.some(JsxRuntime.jsx("p", {
                    children: formSubmitMessage,
                    className: "text-teal-500"
                  }))
        });
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h1", {
                      children: "Survey Form",
                      className: "text-32-px mb-30-px"
                    }),
                tmp,
                JsxRuntime.jsxs("form", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("div", {
                                    children: JsxRuntime.jsx(TextInput$ReactHooksTemplate.make, {
                                          label: "Customer ID",
                                          value: formInfo.customer_id,
                                          handleChange: handleCustomerIDChange
                                        }),
                                    className: "w-1/2"
                                  }),
                              className: "flex mb-30-px items-center"
                            }),
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx("input", {
                                    className: "bg-teal-500 hover:bg-teal-700 py-6-px px-20-px \n                     font-normal text-white font-16-px cursor-pointer",
                                    type: "submit",
                                    value: "Submit"
                                  })
                            })
                      ],
                      onSubmit: (function (param) {
                          param.preventDefault();
                          Js_promise.then_((function (response) {
                                  var status = Json_decode.field("status", Json_decode.string, response);
                                  var description = Json_decode.field("description", Json_decode.string, response);
                                  var exit = 0;
                                  switch (status) {
                                    case "error" :
                                    case "success" :
                                        exit = 1;
                                        break;
                                    default:
                                      Curry._1(setformSubmitMessage, (function (param) {
                                              return "Success.........";
                                            }));
                                  }
                                  if (exit === 1) {
                                    Curry._1(setformSubmitMessage, (function (param) {
                                            return description;
                                          }));
                                  }
                                  return Promise.resolve((console.log(response), undefined));
                                }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/quick_survey", buildSurveyFormDict(formInfo)));
                          return Curry._1(setFormInfo, (function (param) {
                                        return emptyFormInfo;
                                      }));
                        })
                    })
              ],
              className: "p-30-px m-30-px w-2/3 bg-white"
            });
}

var make = QuickSurveyForm;

exports.emptyFormInfo = emptyFormInfo;
exports.make = make;
/* react Not a pure module */
